import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.html',
    styleUrls: ['./../../home.css']
})

export class ConfirmationComponent implements OnInit {
    @Input() elementoDaCancellare: string;

    public confirmCode: string;
    public password: string;

    check(password) {
        return password === this.confirmCode;
    }

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit() {
        this.confirmCode = Math.floor(Math.random() * 0xEFFFF + 0x1000).toString(16);
    }

    setElementoDaCancellare(elementoDaCancellare: string) {
        this.elementoDaCancellare = elementoDaCancellare;
    }

    confirm(password: string) {
        if (this.check(password)) {
            this.activeModal.close();
        } else {
            this.activeModal.dismiss();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/home/sidebar/confirmation/confirmation.ts